import React, { useEffect, useState } from "react";
import { Button, TextField, CircularProgress, Alert } from "@mui/material";
import axios from "axios";
import Hoot from "../../Hoot";

const styles = `
.block{background:var(--card);border:1px solid var(--border);border-radius:18px;padding:14px 16px;}
.head{display:flex;justify-content:space-between;gap:10px;flex-wrap:wrap;margin-bottom:10px;}
.title{font-weight:900;font-size:1.02rem;}
.sub{color:var(--muted);font-size:.78rem;margin-top:2px;}
.table{width:100%;border-collapse:separate;border-spacing:0;font-size:.84rem;}
.table th{text-align:left;padding:.55rem .6rem;font-size:.78rem;font-weight:850;color:var(--muted);border-bottom:1px solid var(--border);}
.table td{padding:.55rem .6rem;border-bottom:1px solid rgba(148,163,184,0.35);vertical-align:top;}
.pill{display:inline-flex;border-radius:999px;padding:2px 10px;font-weight:900;font-size:.72rem;background:rgba(148,163,184,0.14);}
`;

function FeedbacksManager() {
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const [error, setError] = useState(null);
  const [q, setQ] = useState("");

  const load = async () => {
    try {
      setLoading(true);
      setError(null);
      const res = await axios.get(Hoot() + "feedbacks/list", { withCredentials: true });
      setRows(res.data || []);
    } catch {
      setError("Erro ao carregar feedbacks.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const filtered = rows.filter((r) => {
    const s = (q || "").toLowerCase();
    return (
      (r.institute_name || "").toLowerCase().includes(s) ||
      (r.tech_name || "").toLowerCase().includes(s) ||
      (r.title || "").toLowerCase().includes(s)
    );
  });

  return (
    <>
      <style>{styles}</style>
      <div className="block">
        <div className="head">
          <div>
            <div className="title">Feedbacks</div>
            <div className="sub">Avaliações das escolas sobre técnicos</div>
          </div>
          <div className="d-flex gap-2 flex-wrap">
            <Button className="btn-soft" variant="outlined" onClick={load} disabled={loading}>
              {loading ? <CircularProgress size={18} /> : "Atualizar"}
            </Button>
          </div>
        </div>

        {error ? <Alert severity="error">{error}</Alert> : null}

        <div className="d-flex gap-2 flex-wrap" style={{ marginBottom: 10 }}>
          <TextField
            label="Pesquisar feedback"
            variant="outlined"
            size="small"
            value={q}
            onChange={(e) => setQ(e.target.value)}
            style={{ minWidth: 320, flex: 1 }}
          />
        </div>

        <div style={{ overflowX: "auto" }}>
          <table className="table">
            <thead>
              <tr>
                <th>Data</th>
                <th>Escola</th>
                <th>Técnico</th>
                <th>Título</th>
                <th>Nota</th>
                <th>Estado</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map((r) => (
                <tr key={r.id}>
                  <td>{r.date || "—"}</td>
                  <td style={{ fontWeight: 850 }}>{r.institute_name || "—"}</td>
                  <td>{r.tech_name || "—"}</td>
                  <td>{r.title || "—"}</td>
                  <td>{r.score ?? "—"}</td>
                  <td><span className="pill">{r.status || "aberto"}</span></td>
                </tr>
              ))}
              {filtered.length === 0 ? (
                <tr>
                  <td colSpan={6} style={{ color: "var(--muted)", fontSize: ".8rem" }}>
                    Sem dados para mostrar.
                  </td>
                </tr>
              ) : null}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}

export default FeedbacksManager;
